import { render, staticRenderFns } from "./CallDetail.vue?vue&type=template&id=9e71cc0c"
import script from "./CallDetail.vue?vue&type=script&lang=js"
export * from "./CallDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports